// VDV-1938
export const isValkTalkEnabled = (): boolean => process.env.REACT_APP_FEATURE_FLAG_VALK_TALK === 'true'
